import { SET_ICP_DETAILS, UNSET_ICP_DETAILS } from "./icpActionTypes";

export function setIcpDetails(icpData) {
  return { type: SET_ICP_DETAILS, payload: icpData };
}

export function unsetIcpDetails() {
  return { type: UNSET_ICP_DETAILS };
}
